const API_HOST = process.env.REACT_APP_API_HOST || "http://localhost:8080";
const LANGUAGE = process.env.REACT_APP_LANGUAGE || "en";
const AUTH_ENABLED = JSON.parse(process.env.REACT_APP_AUTH_ENABLED || false);

export {
  API_HOST,
  LANGUAGE,
  AUTH_ENABLED
};
